// TODO 预付款API
import {request} from '../jslib/request'
import axios from 'axios'
const BASE_REQUEST = '/tms/businessReport'

export function getShipCostBusinessPayables(querydata) {
  return request({
    url:`${BASE_REQUEST}/getShipCostBusinessPayables`,
    data:querydata
  })
}

export function getShipPayBusinessPayables(querydata) {
  return request({
    url:`${BASE_REQUEST}/getShipPayBusinessPayables`,
    data:querydata
  })
}

export function getShipPayReport(querydata) {
  return request({
    url:`${BASE_REQUEST}/getShipPayReport`,
    data:querydata
  })
}

export function getShipCostReport(querydata) {
  return request({
    url:`${BASE_REQUEST}/getShipCostReport`,
    data:querydata
  })
}
